import { CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from "@heroicons/react/24/outline"
import store, { handleGlobal } from "@/(front-desk)/store"
import { toast } from 'react-toastify'
import { isAxiosError } from "axios"
import * as Sentry from "@sentry/nextjs"

export const toastMessage = (type, message) => {
    const iconList = {
        'info': <InformationCircleIcon />,
        'error': <ExclamationTriangleIcon />,
        'success': <CheckCircleIcon />,
        'default': <InformationCircleIcon />
    }
    const messages = Array.isArray(message) ? message : [message]
    messages.map((msg) => {
        // console.log('msg', msg)
        toast(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            icon: iconList[type],
            theme: "colored",
            type: type
        })
    })
}

// export const statusCheck = (router, project, groupStages, shortcut) => {
//     if (groupStages.data) {
//         const stage = groupStages.data.find(e => e.shortcut === shortcut)
//         const type = stage.type.includes('group') ? 'group' : 'individual'
        
//         if (stage.current_status === 'not-started') {
//             router.push('/user/exhibit')
//         }
//         else if (project?.reviews?.[shortcut] && project.reviews[shortcut].result !== 'init') {
//             if (project.reviews[shortcut].result !== 'fail') {
//                 router.push(`/user/exhibit/${type}/${shortcut}/application`)
//             }
//             else if (project.reviews[shortcut].patch !== true) {
//                 router.push(`/user/exhibit/${type}/${shortcut}/application`)
//             }
//         }
//         else if (stage.current_status !== 'ongoing') {
//             router.push(`/user/exhibit/${type}/${shortcut}/application`)
//         }
//     }
// }
export const statusCheck = (router, type, stageShortcut) => {
    let project
    let stages

    if (type === 'group') {
        project = store.getState().exhibition.groupProject
        stages = store.getState().exhibition.groupStages
    }
    else if (type === 'individual') {
        project = store.getState().exhibition.individualProject
        stages = store.getState().exhibition.individualStages
    }
    
    try {
        const stage = stages.find(e => e.shortcut === stageShortcut)

        if (stage.current_status === 'not-started') {
            // stage not started
            router.push('/user/exhibit')
        }
        else if (!project && !stage.shortcut.includes('registration')) {
            // not registration page and project not found
            router.push('/user/exhibit')
        }
        else if (project?.reviews?.[stageShortcut] && project.reviews[stageShortcut].result !== 'init') {
            // project review exists
            if (project.reviews[stageShortcut].result !== 'fail') {
                // project review result is not fail
                router.push(`/user/exhibit/${type}/${stageShortcut}/application`)
            }
            else if (project.reviews[stageShortcut].patch !== true) {
                // project review result is fail and cannot patch
                router.push(`/user/exhibit/${type}/${stageShortcut}/application`)
            }
        }
        else if (stage.current_status !== 'ongoing') {
            // stage not ongoing
            router.push(`/user/exhibit/${type}/${stageShortcut}/application`)
        }
    }
    catch (error) {
        throw new Error(error)
    }
}
export const scrollToErrorInput = (formElement) => {
    const errorElement = formElement.querySelector('.error')
    // console.log(errorElement)
    if (errorElement) {
        const scrollY = errorElement.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 175
        window.scrollTo({
            top: scrollY,
            left: 0,
            behavior: "smooth",
        })
    }
}

export const useRouterForLink = (aEls, prefetchedLinks, router) => {

    const shouldCatchLinks = (anchor) => {
        const href = anchor.getAttribute('href');
        if (!anchor.hasAttribute('href') || !href?.startsWith('/')) return false;
        if (anchor.hasAttribute('download') === true) return false;
        if (anchor.target === '_blank') return false;
        if (anchor.host !== window.location.host) return false;
        return true;
    }

    const handleClick = (e) => {
        e.preventDefault();
        router.push((e.target).getAttribute('href'));
    };

    const handleMouseEnter = (e) => {
        e.preventDefault();
        const href = (e.target).getAttribute('href');
        if (!prefetchedLinks.has(href)) {
            prefetchedLinks.add(href);
            router.prefetch(href);
        }
    };

    aEls.forEach(a => {
        if (shouldCatchLinks(a)) {
            a.onclick = handleClick;
            a.onmouseenter = handleMouseEnter;
        }
    });
}

export const isObjectEmpty = (object) => {
    return (
        object &&
        Object.keys(object).length === 0 &&
        object.constructor === Object
    );
}

export const fileSizeText = (size) => {
    let text = ""

    if (size > 1024 * 1024) {
        text = (size / (1024 * 1024)).toFixed(2) + "MB"
    } else {
        text = (size / 1024).toFixed(2) + "KB"
    }

    return text
}

export const ellipsisFileName = (filename) => {
    // input: this-is-a-test.jpg output: this⋯test.jpg
    // input: this-is-a-test.abc output: this-is-⋯.abc
    // input: this-is-a-test-doc output: this-is-⋯-doc
    // preserve a bit of tail so it would be easier to read

    const OUTPUT_LENGTH = 30 // OUTPUT_LENGTH should be at least 14 for a better result in worst case (.jpeg)
                             // 12345678901234
                             // head⋯tail.exte
    const TAIL_LENGTH = 4

    // this-is-a-test.jpg
    // match[0] this-is-a-test.jpg
    // match[1] this-is-a-test
    // match[2] .jpg
    // match[3] jpg
    const regex = /([^\/\\]+)(\.(pdf|png|gif|jpg|jpeg))$/i

    let head = filename
    let tail = ""

    const match = filename.match(regex)
    if (match) {
        head = match[1]
        tail = match[2]
    }

    if (filename.length > OUTPUT_LENGTH) {
        const _head = head

        tail = `${_head.slice(_head.length - TAIL_LENGTH)}${tail}` // put the tail from the filename and also the extension if there is a match
        head = `${_head.slice(0, OUTPUT_LENGTH - tail.length - 1)}⋯` // 1 for the dots
    }
    
    return `${head}${tail}`
}

export const getFile = (exhibitionType, stage, fileType) => {
    let project
    if (exhibitionType === 'group') {
        project = store.getState().exhibition.groupProject
    }
    else if (exhibitionType === 'individual') {
        project = store.getState().exhibition.individualProject
    }
    return project?.filepacks?.[stage]?.find(e => e.type.includes(fileType))
}

export const getSamples = (exhibitionType, stage, doctype) => {
    let stages
    if (exhibitionType === 'group') {
        stages = store.getState().exhibition.groupStages
    }
    else if (exhibitionType === 'individual') {
        stages = store.getState().exhibition.individualStages
    }
    return stages?.find(e => e.shortcut === stage)?.doctypes?.find(e => e.shortcut === doctype)?.entries
}

export const reportError = (error, errorPageDisplay) => {
    if (!error) {
        console.error('reportError called without error')
        return
    }
    const eventId = Sentry.captureException(error, {
        extra: isAxiosError(error) ? {
            request: {
                url: error.config?.url,
                method: error.config?.method,
                params: error.config?.params,
                data: error.config?.data,
            },
            response: {
                status: error.response?.status,
                data: JSON.stringify(error.response?.data, null, 2),
            },
        } : null,
    })
    if (errorPageDisplay) {
        store.dispatch(handleGlobal.actions.setSentryErrorEventId(eventId))
    }
}

export const boothSizeDisplay = (size, sizeOther) => {
    return (
        <>
        {size === 'i54' && '自由展位： 6 個'}
        {size === 'i72' && '自由展位： 8 個'}
        {size === 'i81' && '自由展位： 9 個'}
        {size === 'i108' && '自由展位： 12 個'}
        {size === 'i135' && '自由展位： 15 個'}
        {size === 'i144' && '自由展位： 16 個'}
        {size === 'i162' && '自由展位： 18 個'}
        {size === 'other' && `自由展位： ${sizeOther} 平方公尺`}
        {size === 'g1' && '共享展位： 1 個'}
        {size === 'g2' && '共享展位： 2 個'}
        {size === 'g3' && '共享展位： 3 個'}
        {size === 'g4' && '共享展位： 4 個'}
        </>
    )
}